import { imageBitmapToPixels, type ImageSource } from "@/libs/image"
import { throttleMark, type PerformanceEntry } from "@/libs/telemetry/performance"
import type { Graph } from "../../framework"
import type { FramePixels } from "../types"

export const create = <I extends unknown[], O extends unknown[]>(
  graph: Graph<I, O>,
  opts?: { performance?: PerformanceEntry },
) => {
  const mark = throttleMark(opts?.performance, 1000 / 2)

  return graph.node<[ImageSource], [FramePixels]>({
    process: async (ctx) => {
      const processPerf = mark("cv:quality-frame2pixels")
      const source = ctx.in(0)
      const imageBitmap = await createImageBitmap(source)
      const pixels = imageBitmapToPixels(imageBitmap)
      processPerf?.measure()
      ctx.out(0, pixels)
    },
  })
}
